import { type Dispatch, useEffect } from 'react';
import { getLastSearchHotel } from '../../common/lastSearch';
import actions from '../hotelActions';
import type { hotelDefaultState } from '../hotelDefaultState';

export const useHotelInitialState = (
    dispatch: Dispatch<ReturnType<(typeof actions)[keyof typeof actions]>>,
    prefill?: Partial<typeof hotelDefaultState>,
) => {
    useEffect(() => {
        if (!prefill) {
            dispatch(actions.allFieldsChanged(getLastSearchHotel()));
        }
    }, [dispatch, prefill]);
};
